import React from "react";
import cx from "classnames";
import { CheckboxInputWrapper } from "./checkbox.styles";
import { ValidationMessage } from "../validationMessage";

export const Checkbox = React.forwardRef((props, ref) => {
  const {
    name, ariaLabelledby, onChange, onBlur, value, className, errorMessage, hidden, hideErrors, children
  } = props;

  return (
    <CheckboxInputWrapper className={cx(className, {"has-error": errorMessage && !hideErrors})} name={name}>
      <input
        ref={ref}
        name={name}
        type="checkbox"
        aria-labelledby={ariaLabelledby}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        style={{display: hidden ? "none" : "block"}}
      />
      {children}
      <ValidationMessage errorMessage={errorMessage} hideErrors={hideErrors} />
    </CheckboxInputWrapper>
  );
});